import { useState } from "react";

export default function useToggleHandler() {
  const [isOpen, setOpen] = useState<boolean>(false);

  // function
  function toggler() {
    setOpen(!isOpen);
  }
  return { isOpen, toggler };
}
